import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { getStoredCmsPages } from "../Constants";
import { landingPath } from "../services/pageAccess";

/**
 * The sign-in route. An operator who already has a session is sent on to the
 * CMS instead of being shown the login form again.
 *
 * WHERE THEY ARE SENT. This was hard-coded to `/home/users` - the user-
 * administration screen, which most operators are not granted. They would land
 * on it, be refused, and have to find their way out, which is the first thing
 * they would see after returning to a tab they were already signed in to.
 *
 * `landingPath` reads the menu that login stored and returns the first page
 * they actually hold, or the no-permission screen when they hold none.
 */
const PublicRoutes = () => {
  const token = localStorage.getItem("token");
  if (!token) return <Outlet />;

  return <Navigate to={landingPath(getStoredCmsPages())} replace />;
};

export default PublicRoutes;
